import { createAsyncReducer, AsyncActions } from '../../standard-actions/';
import {
    IRemoveDirectDebitAction,
    IRemoveDirectDebitSuccessAction,
    IRemoveDirectDebitErrorAction,
} from '../actions/remove-direct-debit';
import { IBillingState } from '../state';
import { initialState } from '../state/initial-state';

export type RemoveDirectDebitAction
    = IRemoveDirectDebitAction
    | IRemoveDirectDebitSuccessAction
    | IRemoveDirectDebitErrorAction;

const init = (state: IBillingState, action: RemoveDirectDebitAction) => ({
    ...state,
    removeDirectDebit: {
        ...state.removeDirectDebit,
        status: action.status
    },
    showToast: {
        type: '',
        visible: false,
        text: ''
    }
});

const success = (state: IBillingState, action: RemoveDirectDebitAction) => ({
    ...state,
    removeDirectDebit: {
        status: action.status,
        data: (action as IRemoveDirectDebitSuccessAction).data
    },
    ddAgreement: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    showToast: {
        type: 'remove',
        visible: true,
        text: 'Direct debit cancelled'
    }
});

const failure = (state: IBillingState, action: RemoveDirectDebitAction) => ({
    ...state,
    removeDirectDebit: {
        ...initialState.removeDirectDebit,
        status: action.status,
        error: (action as IRemoveDirectDebitErrorAction).error,
        errorCode: (action as IRemoveDirectDebitErrorAction).errorCode
    },
    showToast: {
        type: '',
        visible: false,
        text: ''
    }
});

const notStarted = (state: IBillingState, action: RemoveDirectDebitAction) => ({
    ...state,
    removeDirectDebit: {
        status: action.status,
        data: null
    },
    showToast: {
        type: '',
        visible: false,
        text: ''
    }
});

export const removeDirectDebitReducer = createAsyncReducer(initialState, init, success, failure, notStarted);
